const {pathname} = window.location
  let checkVirtualFairIdp = ''
  if(pathname.includes('virtual-fair-user-preference')){
    checkVirtualFairIdp = "&utm_source=liberal_virtual_fair"
  }else {
    checkVirtualFairIdp = "&utm_source=Long_form"
  }
export const Urls = {
  LOGIN_API: "/api/1/auth/login/",
  LOGOUT_API: "/api/1/auth/logout/",
  LOGIN_REFRESH_API: "/api/1/auth/login/refresh/",
  USER_DETAIL_API: "/api/1/cus/auth/user/",
  USER_AUTH_PERMISSION_API: "/api/1/auth/user/permissions",
  USER_ACTIVITY: "/api/1/user-activity/",
  GET_CMS_PERMISSION_LIST_API: "/api/1/cms/permissions/",
  GET_CMS_CONTENT_TYPE: "/api/1/cms/content_type/",
  GET_CMS_GROUPS_LIST: "/api/1/cms/groups/",
  PUT_CMS_GROUP_PERMISSIONS: "/api/1/cms/groups/",
  GET_USER_LIST_API: "/api/1/users/",
  GET_USER_API: "/api/1/user/",
  
  GET_IDP_MEDICAL_STATUS_API: "/api/medical-idp/mdeical-idp-status",
  GET_IDP_MEDICAL_COMMON_APP_API: "/api/medical-idp/common-app-user-create",
  GET_IDP_MEDICAL_FORM_STATUS_API: "/api/medical-idp/mdeical-idp-status",
  GET_IDP_MEDICAL_DEGREE_API: "/api/medical-idp/degree",
  GET_IDP_MEDICAL_EXAM_API: "/api/medical-idp/exam",
  GET_IDP_MEDICAL_SPECIALIZATION_API: "/api/medical-idp/specialization",
  GET_IDP_MEDICAL_COACHING_API: "/api/medical-idp/coaching",
  GET_IDP_MEDICAL_COACHING_LIST_API: "/api/medical-idp/mdeical-idp-coaching-list",
  GET_IDP_MEDICAL_COACHING_LOCATION_API: "/api/medical-idp/coaching-location",

  GET_IDP_MEDICAL_COACHING_MODE_API: "/api/medical-idp/mode",

  GET_IDP_MEDICAL_PREFFERED_LOCATION_API: "/api/medical-idp/preffered-location",
  GET_IDP_MEDICAL_PREFFERED_INSTITUTE_API:
    "/api/medical-idp/preffered-institute",
  GET_IDP_MEDICAL_PRODUCT_API:'api/medical-idp/product',
  GET_IDP_MEDICAL_OTHER_SPECIALIZATION_API:
    "/api/medical-idp/other-specialization",
  GET_IDP_MEDICAL_COLLEGE_API: "/api/medical-idp/college",
  POST_IDP_MEDICAL_SUBMIT_API: "/api/medical-idp/submit",
  GET_IDP_LEAD_CREATE_API: "/api/idp-leads-create",

  GET_IDP_ENGINEERING_API: "/api/1/user_dashboard/get-idp",
  GET_IDP_ENGINEERING_NONPAN_COLLEGES_API: "/api/1/user_dashboard/location-based-colleges",
  POST_IDP_ENGINEERING_API: "/api/1/user_dashboard/post-common-idp?idp=1"+checkVirtualFairIdp,
  POST_IDP_IMS_PUSH_API: "/api/1/user_dashboard/lms-push",
  POST_IDP_SCHOOL_API: "/api/1/user_dashboard/school-idp-post?idp=1",
  POST_IDP_STUDYABROAD_API: "/api/1/user_dashboard/study-abroad-post",

  PUSH_CLEVERTAP_DATA: "/dj-api/push-clever-tap-data"
};
export const BASE_URL = process.env.REACT_APP_API_URL;
